<template>
  <div v-if="loading || editorLoading">
    <div style="height: 90vh" v-loading="true"></div>
  </div>
  <div v-else>
    <!-- FlowHeader, Menu -->
    <div class="flex mb-4">
      <div class="flex-grow">
        <FlowHeader v-if="tradingInfo" :tradingInfo="tradingInfo" />
      </div>
      <div class="flex align-center">
        <div class="process-show-switch-form">
          <label>Process</label>
          <el-switch
            class="process-show-switch"
            v-model="processVisible"
            active-color="#5185C5"
            active-icon-class="tw-icon-view"
            inactive-icon-class="tw-icon-not-view"
          ></el-switch>
        </div>
        <div class="buttons">
          <TwButton v-if="!editMode && editable && (isShipper || isFwd) && (!isFwd || tradingInfo.isOwnerFlg === 1)" :disabled="!canEditFlow || forbidden" type="primary" @click="handleEdit">Edit</TwButton>
        </div>
        <div class="pt-2">
          <TwMenuButton
            v-if="!editMode && editable && (isShipper || isFwd)"
            :items="menuItems"
            @select="handleClickMenu"
          >
            Menu
          </TwMenuButton>
        </div>
      </div>
    </div>

    <div
      class="flex align-center mb-3 pb-3"
      style="border-bottom: 1px solid #eee;"
    >
      <div class="text-24 text-bold flex-grow text-gray-800 flex align-end">
        <!-- 取引フロー詳細見出し -->
        <div>
          {{ pageTitle }}
        </div>
        <div
          v-if="displayTradingFlowId"
          class="ml-4 text-12 text-gray-400 copyable"
        >
          ID: {{ displayTradingFlowId }}
        </div>
      </div>

      <!-- 編集モードでボタンを表示 -->
      <div v-if="editMode" style="width:400px;">
        <div>
          <div class="flex justify-end">
            <TwButton @click="handleCancel">
              Cancel
            </TwButton>
            <TwButton
              v-if="tradingInfo.tradingSubmitStatusCd === 1"
              type="primary"
              @click="handleSave"
            >
              Save
            </TwButton>
            <TwButton type="primary" @click="handleRegister">
              Register
            </TwButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit FlowName -->
    <div v-if="editMode" class="flex flex-row align-start py-4">
      <div class="flex-grow">
        <el-form
          :model="formFlowName"
          ref="formComponent"
          class="flex-grow"
          :rules="rules"
          label-width="120px"
          label-position="left"
        >
          <!-- フロー名 -->
          <el-form-item :label="$t(`List.Flow Name`)" prop="tradingManageName">
            <el-input
              style="width: 450px"
              v-model="formFlowName.tradingManageName"
              @input="$emit('dirty')"
              show-word-limit
              maxlength="100"
            />
          </el-form-item>

          <div class="flex flex-wrap">
            <!-- フローReference -->
            <el-form-item
              :label="$t(`Label.Flow Reference`)"
              prop="flowReference"
              style="display: inline-block; margin-right: 10px; width: 500px;"
              >
              <el-input
                style="width: 350px"
                v-model="formFlowName.flowReference"
                @input="$emit('dirty')"
                show-word-limit
                maxlength="100"
              />
            </el-form-item>
            <!-- フロー担当者 -->
            <el-form-item
              :label="$t(`Label.Flow PIC`)"
              prop="flowUserName"
              style="display: inline-block; width: 620px;"
              >
              <el-input
                style="width: 350px"
                v-model="formFlowName.flowUserName"
                @input="$emit('dirty')"
                show-word-limit
                maxlength="100"
              />
              <tw-button style="margin-left: 10px" type="secondary" size="small" @click="assignMe">Assign Me</tw-button>
            </el-form-item>
        </div>
        </el-form>
      </div>
    </div>

    <!-- FlowOverview-->
    <div class="mb-4">
      <FlowOverview
        v-if="!isNew && flowInfo"
        :flowInfo="flowInfo"
        :editMode="editMode"
      />
    </div>

    <!-- プロセス追加 -->
    <div class="flex justify-end my-3">
      <AddProcessCascader
        v-if="editMode && processList && !isFwd"
        :flowInfo="tmpFlowInfo"
        :processList="processList"
        @select-process="addProcess"
      />
    </div>

    <!-- ProcessList ( display, EditForm ) -->
    <div class="mb-6">
      <el-form :model="formData" ref="formProcessComponent">
        <DetailProcessFormTable
          :loading="editorLoading"
          :cols="filteredSchema"
          :tableData="tableData"
          :editMode="editMode"
          @update-prop="updateFlowValue"
          @click-delete-process="removeProcess"
        />
      </el-form>
    </div>
    <tw-drawer>
      <template slot>
        <tw-trading-detail-inner v-if="drawerShow" :tradingId="selectTradingId" :tradingFlowId="selectFlowId" />
      </template>
    </tw-drawer>
    <!-- 分納モード -->
    <el-drawer
      :visible.sync="isShowPartial"
      :title="$t('Label.Partial')"
      size="100%"
      :before-close="closePartial"
    >
      <tw-partial-view
        v-if="isShowPartial"
        ref="partial"
        :tradingId="tradingInfo.tradingId"
        :tradingFlowId="tradingFlowId"
        :tradingName="tradingInfo.tradingName"
        :editable="editable"
        :mode="null"
        @partial-registered="onPartialRegistered"
        @cancel="closePartial"
        @show-flow-detail="showFlowDetail"
      />
    </el-drawer>

    <!-- 混載モード -->
    <el-drawer
      :visible.sync="isShowCombine"
      :title="$t('Label.Combine')"
      size="100%"
      :before-close="closeCombine"
    >
      <TwCombineView
        v-if="isShowCombine"
        ref="combine"
        :tradingId="tradingInfo.tradingId"
        :tradingFlowId="tradingFlowId"
        :tradingName="tradingInfo.tradingName"
        :editable="editable"
        :mode="null"
        @partial-registered="onCombineRegistered"
        @cancel="closeCombine"
        @show-flow-detail="showFlowDetail"
      />
    </el-drawer>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  defineComponent,
  computed,
  ref,
  reactive,
  watch,
  onMounted,
  getCurrentInstance,
} from '@vue/composition-api';
import {
  EDITABLE_FLG,
  SECTION_PREFIX,
  DELETE_ABLE_FLG,
  PROCESS_CANCEL_FLG,
  TRADING_PROGRESS_STATUS,
  PROCESS_PROGRESS_STATUS,
  COPYABLE_FLG,
  LANGUAGE_CODE,
  IS_OWNER_FLG,
  FLOW_HIDDEN_FLAG,
  TRADING_REGISTRATION_STATUS,
} from 'lib-tw-common';

import { orderProcesses } from '@/utils/entity.js';
import {
  generateUuid,
  orderEntities,
  MAX_PROCESS_NUMBER,
  mapToSchemaList,
} from '@/utils/searchUtil.js';

import { useBffTradingManagesSearch } from '@/composables/useBffTradingManagesSearch';
import { useBffTradingManagesEditor } from '@/composables/useBffTradingManagesEditor';
import { useLakeelValidation } from '@/composables/useLakeelValidation';

// schema
import { tradingDetailTableSchema } from '@/dictionaries/vue3/tradingDetailTableSchema.js';
import { tradingDetailTableFormSchema } from '@/dictionaries/vue3/tradingDetailTableFormSchema.js';
import { processNames as processNamesMap } from '@/dictionaries/map.js';

import { $api } from '@/store/ApiClient';
import { MAX_TRADING_FLOW_COUNT } from '@/utils/constants';

import TwButton from '@/components/atoms/TwButton.vue';
import TwEntityIcon from '@/components/atoms/TwEntityIcon.vue';

// vue3 components
import TwHeader from '@/components/vue3/TwHeader.vue';
import TwMenuButton from '@/components/vue3/TwMenuButton.vue';

import TwPartialView from '@/components/templates/TwPartialView';
import TwCombineView from '@/components/templates/TwCombineView';
import TwDrawer from '@/components/organisms/TwDrawer';
import TwTradingDetailInner from '@/components/templates/TwTradingDetailInner';
import DetailProcessFormTable from './DetailProcessFormTable.vue';

import FlowHeader from './FlowHeader.vue';
import FlowOverview from './FlowOverview.vue';
import AddProcessCascader from './AddProcessCascader.vue';

export default defineComponent({
  name: 'TradingFlowDetailList',
  components: {
    TwHeader,
    TwButton,
    TwEntityIcon,
    TwMenuButton,
    FlowHeader,
    FlowOverview,
    DetailProcessFormTable,
    TwPartialView,
    TwCombineView,
    AddProcessCascader,
    TwDrawer,
    TwTradingDetailInner,
  },
  props: {
    onToggleCollapse: {
      type: Function,
      default: () => {},
    },
  },
  setup(props, { root }) {
    // TODO: vue3時に書き換え
    const vm = getCurrentInstance().proxy;
    // eslint-disable-next-line no-deprecated-api
    const route = root.$route;

    // routerから取引/フローIDを取得
    const tradingId = route?.params.tradingId;
    const tradingFlowId = route?.params.tradingFlowId;
    const selectTradingId = ref('');
    const selectFlowId = ref('');

    /* ==========

      reactive

      ========== */

    const language = root.$store.state.locale;
    const lang = _.get(LANGUAGE_CODE, `${language}`, 'ja');

    const formComponent = ref(null);
    const formProcessComponent = ref(null);
    const tradingPatternId = ref('');

    const editMode = ref(false);
    const formData = reactive({});
    const formFlowName = reactive({
      tradingManageName: '',
      flowReference: '',
      flowUserName: ''
    });

    const tableData = ref([]);
    const tmpFlowInfo = ref(null);

    const deleteTradingFlowIds = ref([]);
    const isDirty = ref(false);

    const isNew = ref(route?.params.tradingFlowId === 'new');
    const isShowPartial = ref(false);
    const isShowCombine = ref(false);
    const editable = ref(false);

    const processVisible = ref(true);

    const pageTitle = computed(() => {
      return editMode.value
        ? lang === 'ja'
          ? '	フロー/プロセス 編集'
          : 'Edit Flow / Process List'
        : lang === 'ja'
          ? 'フロー/プロセス一覧'
          : 'Flow / Process List';
    });

    const displayTradingFlowId = computed(() => {
      return `${tradingId}/${tradingFlowId}`;
    });

    const companyId = computed(() => {
      return root.$store.state.companyId;
    });

    const isShipper = computed(() => {
      // カンパニーロールが荷主か
      return root.$store.getters.isShipper;
    });

    const isFwd = computed(() => {
      return root.$store.getters.isFwd;
    });

    const drawerShow = computed(() => {
      return root.$store.state.drawerShow;
    });

    const forcedClose = ref(null); // フロー非表示フラグ。区分値：FLOW_HIDDEN_FLAGに対応しておりnull,0,1を想定。src\utils\searchUtil.jsの【取引一覧のforcedClose補足】参照。
    const isForcedCloseUpdateAction = ref(false); // Save,Register押下後にEditModeにする/しないの切り替えがあるためbooleanを設ける

    const filteredSchema = computed(() => {
      return editMode.value
        ? tradingDetailTableFormSchema
        : processVisible.value
          ? tradingDetailTableSchema
          : tradingDetailTableSchema.filter(col => col.key !== 'processName');
    });

    const canEditFlow = computed(() => {
      return (
        _.get(editorFlowInfo.value, 'editableFlg') === EDITABLE_FLG.ON
      );
    });

    const copyable = computed(() => {
      return (
        editorTradingInfo.value?.tradingPatternInfo &&
        editorFlowInfo.value &&
        editorFlowInfo.value.copyableFlg === COPYABLE_FLG.ON
      );
    });

    const canPartial = computed(() => {
      return (
        !isDirty.value &&
        _.get(editorFlowInfo.value, 'subordinateInfo.canPartialShipmentFlg')
      );
    });
    const canCombine = computed(() => {
      return (
        !isDirty.value &&
        _.get(editorFlowInfo.value, 'subordinateInfo.canCombineFlg')
      );
    });

    const menuItems = computed(() => {
      const menu = [];

      if (!isFwd.value || tradingInfo.value?.isOwnerFlg === IS_OWNER_FLG.ON) {
        menu.push({
          label: root.$t('Label.Copy Flow'),
          value: 'copy',
          disabled:
            !copyable.value ||
            tradingInfo.value?.tradingSubmitStatusCd ===
              TRADING_REGISTRATION_STATUS.SAVING,
          gtm: 'copy_flow_click'
        });
      }

      if (isShipper.value && editable.value) {
        menu.push({ label: root.$t('Label.Partial'), value: 'partial', disabled: !canPartial.value });
        menu.push({ label: root.$t('Label.Combine'), value: 'combine', disabled: !canCombine.value });
      }

      const targetFlow = tradingInfo.value?.tradingFlowList.find(item => item.tradingFlowId === tradingFlowId);
      if (tradingInfo.value?.isOwnerFlg === IS_OWNER_FLG.ON) {
        if (targetFlow.forcedClose === FLOW_HIDDEN_FLAG.HIDDEN) {
          menu.push({
            label: root.$t('Label.Show Flow'),
            value: 'showFlow',
          });
        } else {
          menu.push({
            label: root.$t('Label.Hide Flow'),
            value: 'hideFlow',
          });
        }
      }

      if (!isFwd.value || tradingInfo.value?.isOwnerFlg === IS_OWNER_FLG.ON) {
        menu.push({
          label: root.$t('Label.Delete Flow'),
          value: 'delete',
          disabled:
            targetFlow.tradingProgressStatusCd !==
            TRADING_PROGRESS_STATUS.NOT_STARTED,
        });
      }

      // if (canPartial.value) {
      //   menu.push({ label: 'Partial', value: 'partial' });
      // }
      // if (canCombine.value) {
      //   menu.push({ label: 'Combine', value: 'combine' });
      // }
      return menu;
    });

    const { onEventValidation, validationCheck } = useLakeelValidation(
      root.$store,
      formFlowName,
      formComponent,
    );

    const {
      loading,
      tradingInfo,
      flowInfo,
      processData,
      refresh,
    } = useBffTradingManagesSearch(
      {
        tradingId,
        tradingFlowId
      },
      true,
      tradingFlowId,
    );

    const rules = {
      tradingManageName: [
        {
          lakeelMessageSourceFlg: true,
          validationId: 'tw-isMaxLength100',
          validator: onEventValidation,
          trigger: 'blur',
          field: 'tradingManageName',
          label: 'tradingManageName',
        },
      ],
      flowReference: [
        {
          lakeelMessageSourceFlg: true,
          validationId: 'tw-isMaxLength100',
          validator: onEventValidation,
          trigger: 'blur',
          field: 'flowReference',
          label: 'flowReference',
        },
      ],
      flowUserName: [
        {
          lakeelMessageSourceFlg: true,
          validationId: 'tw-isMaxLength100',
          validator: onEventValidation,
          trigger: 'blur',
          field: 'flowUserName',
          label: 'flowUserName',
        },
      ],
    };

    const managesEditorParams = {
      path: {},
      queries: {},
      immediate: false,
      tradingFlowId,
    };

    // スキーマでのeditable制御と返り値のeditable制御両方入れるか
    const {
      loading: editorLoading,
      forbidden,
      processList,
      processData: editorProcessData,
      tradingInfo: editorTradingInfo,
      flowInfo: editorFlowInfo,
      fetchData: fetchEditData,
    } = useBffTradingManagesEditor(managesEditorParams);

    /* ========== Watch ========== */

    watch(tradingInfo, newVal => {
      tableData.value = processData.value;
      tradingPatternId.value = newVal.tradingPatternId;
      editable.value = newVal.editableFlg === EDITABLE_FLG.ON;
      fetchEditData({
        path: { companyId: companyId.value },
        queries: {
          tradingPatternId: newVal.tradingPatternId,
          tradingId: newVal.tradingId,
          tradingFlowId: tradingFlowId
        },
      });
    });

    watch(editorTradingInfo, newVal => {
      formData.value = flatten(newVal.tradingFlowList, 'linkageInfo');
      tmpFlowInfo.value = _.find(formData.value, { tradingFlowId });
      if (tmpFlowInfo.value.tradingManageName !== '') formFlowName.tradingManageName = tmpFlowInfo.value.tradingManageName;
      if (tmpFlowInfo.value.flowReference !== '') formFlowName.flowReference = tmpFlowInfo.value.flowReference;
      if (tmpFlowInfo.value.flowUserName !== '') formFlowName.flowUserName = tmpFlowInfo.value.flowUserName;
      tableData.value = editorProcessData.value;
    });

    /* ========== Methods ========== */

    const assignMe = () => {
      formFlowName.flowUserName = root.$store.state.userProfile.userName;
    }

    const historyBack = () => {
      props.onToggleCollapse(false);
      window.history.back();
    };

    const handleEdit = async () => {
      await fetchEditData({
        path: { companyId: companyId.value },
        queries: {
          tradingPatternId: tradingPatternId.value,
          tradingId: tradingId,
          tradingFlowId: tradingFlowId
        },
      });
      editMode.value = !editMode.value;
    };

    // 取引フロー上限到達時のダイアログを表示します
    const showFlowLimitDialog = () => {
      root.$store
        .dispatch('SHOW_CONFIRM_CUSTOM', {
          message: root.$t('Message.FlowCountLimitReached', {
            max: MAX_TRADING_FLOW_COUNT,
          }),
          confirmButtonText: root.$t('Label.Create New Trading'),
          cancelButtonText: root.$t('Label.Close'),
        })
        .then(() => root.$router.push('/trading/new/')) // 新規取引作成画面へ
        .catch(() => {});
    };

    // 現在の取引フロー件数を取得します
    const fetchCurrentFlowCount = async () => {
      // 取引一覧検索(get_/v1/tradings/search)は期間未指定時にBFFが直近N日(既定180日)を補完し、
      // totalCountが「直近N日に更新されたフロー数」になるため件数取得には使わない。
      // 旧取引管理・フロー登録画面(DetailAddFlow)と同じ取引管理検索BFFから全期間の総数を取得する。
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/tradings/manages/search',
          query: {
            tradingId: tradingId || '',
          },
        },
      };
      const res = await $api.request(params);
      return res.tradingInfo.totalTradingFlowCount || 0;
    };

    const handleClickMenu = async command => {
      if (command == 'copy') {
        let count;
        try {
          count = await fetchCurrentFlowCount();
        } catch (err) {
          root.$store.dispatch(
            'SHOW_ALERT',
            root.$t('Message.ERROR__FLOW_COUNT_CHECK_FAILED'),
          );
          return;
        }
        if (count >= MAX_TRADING_FLOW_COUNT) {
          showFlowLimitDialog();
          return;
        }
        const path = `/trading/process/${tradingId}/new?cid=${tradingFlowId}`;
        root.$router.push(path);
      }
      if (command === 'partial') {
        isShowPartial.value = true;
      }
      if (command === 'combine') {
        isShowCombine.value = true;
      }
      if (command === 'showFlow' || command === 'hideFlow') {
        isForcedCloseUpdateAction.value = true;
        if (command === 'showFlow') { forcedClose.value = FLOW_HIDDEN_FLAG.NOT_HIDDEN; } // 0
        if (command === 'hideFlow') { forcedClose.value = FLOW_HIDDEN_FLAG.HIDDEN; } // 1
        tradingInfo.value?.tradingSubmitStatusCd === TRADING_REGISTRATION_STATUS.SAVING ? handleSave() : handleRegister();
      }
      if (command === 'delete') {
        const targetFlow = tradingInfo.value?.tradingFlowList.find(
          item => item.tradingFlowId === tradingFlowId,
        );
        const flowType = _.get(targetFlow, 'tradingChannelInfo.flowType');
        let message = '';
        if (flowType) {
          message =
            'Offshore trading is selected. Are you sure you want to delete the set of paired export and import flows?';
        } else {
          message = root.$t('Message.CONFIRM__DATA_DELETE');
        }
        root.$store
          .dispatch('SHOW_CONFIRM', message)
          .then(() => {
            const count = tradingInfo.value?.totalTradingFlowCount || 0;
            if (count <= 1) {
              root.$store.dispatch(
                'SHOW_ALERT',
                root.$t('Message.ERROR__LAST_FLOW'),
              );
              return;
            }
            const index = _.findIndex(formData.value, item => {
              return item.tradingFlowId === tradingFlowId;
            });
            formData.value.splice(index, 1);
            deleteTradingFlowIds.value.push(tradingFlowId);

            deleteFlow();
          })
          .catch(e => {
            console.log(e);
          });
      }
    };

    const handleRegister = async () => {
      if (editMode) {
        register();
      }
    };

    const deleteFlow = async () => {
      root.$store.commit('START_PROCESS');

      const tradingFlowList = _.map(formData.value, flow => {
        const entityStatus = _.map(flow.entityStatus, s => {
          return {
            ...s,
            provisionalId: s.entityId ? undefined : generateUuid(20),
          };
        });
        return {
          ...flow,
          entityStatus: entityStatus,
        };
      });

      const data = {
        tradingInfo: {
          tradingId: editorTradingInfo.value.tradingId,
          tradingCreateUserId: editorTradingInfo.value.tradingCreateUserId,
          tradingCreateUserName: editorTradingInfo.value.tradingCreateUserName,
          tradingCreateUserIcon: editorTradingInfo.value.tradingCreateUserIcon,
          tradingCreateDate: editorTradingInfo.value.tradingCreateDate,
          tradingUpdateUserId: editorTradingInfo.value.tradingUpdateUserId,
          tradingUpdateDate: editorTradingInfo.value.tradingUpdateDate,
          tradingTrx: editorTradingInfo.value.tradingTrx,
          tradingName: editorTradingInfo.value.tradingName,
          tradingPatternInfo: editorTradingInfo.value.tradingPatternInfo,
          tradingFlowList: tradingFlowList,
          selectTradingFlowIds: [tradingFlowId],
          deleteTradingFlowIds: [tradingFlowId],
        },
      };

      const params = {
        // bff_td_10 取引管理新規登録BFF
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode:
            tradingInfo.value?.tradingSubmitStatusCd ===
            TRADING_REGISTRATION_STATUS.SAVING
              ? 'post_/v1/tradings/{companyId}/manages/wk'
              : 'post_/v1/tradings/{companyId}/manages',
          path: {
            companyId: companyId.value,
          },
        },
        data: data,
      };

      $api
        .request(params)
        .then(res => {
          root.$store.commit('END_PROCESS');
          root.$store.dispatch('SHOW_COMPLETED');
          const path = `/trading?fid=${tradingId}`;
          root.$router.push(path);
        })
        .catch(err => {
          root.$store.commit('END_PROCESS');
          if (err.response?.errors?.[0]?.code === 'ETNC0214') {
            root.$store.dispatch('SHOW_ALERT', root.$t('Message.ERROR__DATA_CONFLICT'));
          } else {
            root.$store.dispatch('SHOW_ALERT', err.message);
          }
        });
    };

    const handleCancel = () => {
      root.$store
        .dispatch(
          'SHOW_CONFIRM',
          root.$t('Message.CONFIRM__NAVIGATION_WITH_UNSAVED_DATA'),
        )
        .then(async () => {
          isDirty.value = false;
          deleteTradingFlowIds.value = [];
          refresh();
          editMode.value = !editMode.value;
        })
        .catch(() => {});
    };

    // 指定したオブジェクトの中身を一階層上に展開
    const flatten = (ary, target) => {
      return _.map(ary, o => {
        return { ..._.omit(o, [target]), ...o.linkageInfo };
      });
    };

    // 採番したprocessIdを返却します
    const getProcessId = processId => {
      if (
        !['ECREQ', 'ICREQ', 'TPBLI', 'FDCOR', 'FDCOI', 'MIRIP'].includes(
          processId,
        )
      ) {
        return processId;
      }
      const filtered = _.filter(tableData.value, item => {
        return (
          item.processId.startsWith(processId) &&
          !(
            item.eventCancel === PROCESS_CANCEL_FLG.ON &&
            [
              PROCESS_PROGRESS_STATUS.AGREED,
              PROCESS_PROGRESS_STATUS.DONE,
            ].includes(item.processProgressStatusCd)
          )
        );
      });
      let ret;
      _.times(MAX_PROCESS_NUMBER[processId], i => {
        if (!_.find(filtered, { processId: `${processId}0${i + 1}` }) && !ret) {
          ret = `${processId}0${i + 1}`;
        }
      });
      if (!ret) {
        ret = `${processId}01`;
      }
      return ret;
    };

    const addProcess = process => {
      const entityTypeCd = process[0];
      const processId = getProcessId(process[1]);
      const processType = _.get(processNamesMap[process[1]], 'processType');

      const flow = tmpFlowInfo.value;
      const processName =
        processType === 'PT_TPATPRB'
          ? _.get(_.find(processNamesMap, { processId }), 'nameEn')
          : _.get(
              _.find(processNamesMap, {
                processType,
              }),
              'nameEn',
            );
      const newProcess = {
        processType,
        processId,
        processName,
        processProgressStatusCd: 0,
        processUserMemo: '',
        fromCompanyRoleCd: '',
        fromCustomerId: '',
        fromCompanyId: '',
        fromSectionId: '',
        fromSectionName: '',
        toCompanyRoleCd: '',
        toCustomerId: '',
        toCompanyId: '',
        toSectionId: '',
        toSectionName: '',
        uuid: generateUuid(),
        editableFlg: EDITABLE_FLG.ON,
        deletableFlg: DELETE_ABLE_FLG.OK,
      };

      const entityStatus = _.find(flow.entityStatus, {
        entityTypeCd,
      });

      if (entityStatus) {
        entityStatus.processStatus.push(newProcess);
      } else {
        flow.entityStatus.push({
          entityTypeCd,
          processStatus: [newProcess],
        });
      }

      const ordered = orderProcesses(orderEntities(flow.entityStatus));

      flow.entityStatus.splice(0, flow.entityStatus.length);
      flow.entityStatus.push(...ordered);
      tableData.value = mapToSchemaList(flow);
    };

    const updateFlowValue = payload => {
      const { row, prop, value } = payload;
      const processId = row.processId;

      for (const entity of tmpFlowInfo.value.entityStatus) {
        const target = entity.processStatus.find(
          p => p.processId === processId,
        );
        if (target) {
          if (prop === 'from' || prop === 'to') {
            if (value.sectionId.startsWith(SECTION_PREFIX.SECTION_PREFEX)) {
              target[`${prop}CustomerId`] = value.tradingId;
              target[`${prop}CompanyId`] = null;
            } else {
              target[`${prop}CompanyId`] = value.tradingId;
              target[`${prop}CustomerId`] = null;
            }
            target[`${prop}CompanyShortName`] = value.tradingShortName;
            target[`${prop}CompanyName`] = value.tradingName;
            target[`${prop}SectionId`] = value.sectionId;
            target[`${prop}SectionName`] = value.sectionName;
            target[`${prop}SectionShortName`] = value.sectionShortName;
            isDirty.value = true;
          } else {
            target[prop] = value;
            isDirty.value = true;
          }
          break;
        }
      }
      tableData.value = mapToSchemaList(tmpFlowInfo.value);
    };

    const removeProcess = payload => {
      const { process: p } = payload;
      const entity = _.find(tmpFlowInfo.value.entityStatus, {
        entityTypeCd: p.entityTypeCd,
      });

      const flowType = _.get(tmpFlowInfo.value, 'tradingChannelInfo.flowType');

      // 三国間取引のフローかつ、フロー内のエンティティが1つで、かつそのエンティティのプロセスが1つの場合、フローを削除するかどうかを確認します
      if (
        flowType &&
        tmpFlowInfo.value.entityStatus.length === 1 &&
        entity.processStatus.length === 1
      ) {
        // this.removeFlow(flow);
      } else {
        const index = _.findIndex(entity.processStatus, o => {
          return (
            o.processId === p.processId &&
            (o.processSeq ? o.processSeq === p.processSeq : o.uuid === p.uuid)
          );
        });

        if (!tmpFlowInfo.value.deleteProcessIds) {
          tmpFlowInfo.value.deleteProcessIds = [];
        }

        tmpFlowInfo.value.deleteProcessIds.push({
          entityId: p.entityId,
          deleteProcessId: p.processId,
          deleteProcessSeq: p.processSeq,
        });
        entity.processStatus.splice(index, 1);
        if (_.isEmpty(entity.processStatus)) {
          tmpFlowInfo.value.entityStatus.splice(
            _.findIndex(tmpFlowInfo.value.entityStatus, {
              entityTypeCd: p.entityTypeCd,
            }),
            1,
          );
        }
        if (_.isEmpty(tmpFlowInfo.value.entityStatus)) {
          const tradingFlowId = tmpFlowInfo.value.tradingFlowId;
          // tmpFlowInfo.value.splice(_.findIndex(this.form.items, flow), 1);
          if (tradingFlowId) {
            deleteTradingFlowIds.value.push(tradingFlowId);
          }
        }

        tableData.value = mapToSchemaList(tmpFlowInfo.value);
        isDirty.value = true;
      }
    };

    // 指定されていないセクションがあるかを返却します
    const hasEmptySections = () => {
      return !!formProcessComponent.value?.$el.querySelector('.invalid');
    };

    // 削除したプロセスがあればコンファームを出します
    const confirmDeleteProcess = async () => {
      const count = _.size(tmpFlowInfo.value?.deleteProcessIds);
      if (count === 0) {
        return true;
      } else {
        return await root.$store
          .dispatch(
            'SHOW_CONFIRM',
            root.$t('Message.CONFIRM__PROCESS_DELETE'),
          )
          .then(() => true)
          .catch(() => false);
      }
    };

    const handleSave = async () => {
      if ((await confirmDeleteProcess()) === false) {
        return;
      }
      // 登録時のローディング画面表示
      root.$store.commit('START_PROCESS');
      const result = await validationCheck();
      if (!result) {
        root.$store.commit('END_PROCESS');
        root.$store.dispatch(
          'SHOW_ALERT',
          root.$t('Message.ERROR__INPUT_INVALID'),
        );
      }

      const tradingFlowList = _.map(formData.value, flow => {
        const entityStatus = _.map(flow.entityStatus, s => {
          return {
            ...s,
            provisionalId: s.entityId ? undefined : generateUuid(20),
          };
        });
        return {
          ...flow,
          entityStatus: entityStatus,
        };
      });
      const targetIndex = _.findIndex(tradingFlowList, { tradingFlowId });

      tradingFlowList[targetIndex].tradingManageName = formFlowName.tradingManageName;
      tradingFlowList[targetIndex].flowReference = formFlowName.flowReference;
      tradingFlowList[targetIndex].flowUserName = formFlowName.flowUserName;
      tradingFlowList[targetIndex].forcedClose = forcedClose.value;

      const data = {
        tradingInfo: {
          tradingId: editorTradingInfo.value.tradingId,
          tradingCreateUserId: editorTradingInfo.value.tradingCreateUserId,
          tradingCreateUserName: editorTradingInfo.value.tradingCreateUserName,
          tradingCreateUserIcon: editorTradingInfo.value.tradingCreateUserIcon,
          tradingCreateDate: editorTradingInfo.value.tradingCreateDate,
          tradingUpdateUserId: editorTradingInfo.value.tradingUpdateUserId,
          tradingUpdateDate: editorTradingInfo.value.tradingUpdateDate,
          tradingTrx: editorTradingInfo.value.tradingTrx,
          deleteTradingFlowIds: props.deleteTradingFlowIds,
          tradingName: editorTradingInfo.value.tradingName,
          tradingPatternInfo: editorTradingInfo.value.tradingPatternInfo,
          tradingFlowList: tradingFlowList,
          selectTradingFlowIds: [tradingFlowId]
        },
      };

      const params = {
        // bff_td_10 取引管理新規登録BFF
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'post_/v1/tradings/{companyId}/manages/wk',
          path: {
            companyId: companyId.value,
          },
        },
        data: data,
      };

      $api
        .request(params)
        .then(res => {
          root.$store.commit('END_PROCESS');
          root.$store.dispatch('SHOW_COMPLETED');
          refresh();
          editMode.value = isForcedCloseUpdateAction.value ? false : !editMode.value;
        })
        .catch(err => {
          root.$store.commit('END_PROCESS');
          if (err.response?.errors?.[0]?.code === 'ETNC0214') {
            root.$store.dispatch('SHOW_ALERT', root.$t('Message.ERROR__DATA_CONFLICT'));
          } else {
            root.$store.dispatch('SHOW_ALERT', err.message);
          }
        });
    };

    const register = async () => {
      if (hasEmptySections()) {
        root.$store.dispatch(
          'SHOW_ALERT',
          root.$t('Message.ERROR__INPUT_INVALID'),
        );
        return;
      }

      if ((await confirmDeleteProcess()) === false) {
        return;
      }

      root.$store.commit('START_PROCESS');
      const result = await validationCheck();
      if (!result) {
        root.$store.commit('END_PROCESS');
        root.$store.dispatch(
          'SHOW_ALERT',
          root.$t('Message.ERROR__INPUT_INVALID'),
        );
      }

      const tradingFlowList = _.map(formData.value, flow => {
        const entityStatus = _.map(flow.entityStatus, s => {
          return {
            ...s,
            provisionalId: s.entityId ? undefined : generateUuid(20),
          };
        });
        return {
          ...flow,
          entityStatus: entityStatus,
        };
      });
      const targetIndex = _.findIndex(tradingFlowList, { tradingFlowId });

      tradingFlowList[targetIndex].tradingManageName = formFlowName.tradingManageName;
      tradingFlowList[targetIndex].flowReference = formFlowName.flowReference;
      tradingFlowList[targetIndex].flowUserName = formFlowName.flowUserName;
      tradingFlowList[targetIndex].forcedClose = forcedClose.value;

      const data = {
        tradingInfo: {
          tradingId: editorTradingInfo.value.tradingId,
          tradingCreateUserId: editorTradingInfo.value.tradingCreateUserId,
          tradingCreateUserName: editorTradingInfo.value.tradingCreateUserName,
          tradingCreateUserIcon: editorTradingInfo.value.tradingCreateUserIcon,
          tradingCreateDate: editorTradingInfo.value.tradingCreateDate,
          tradingUpdateUserId: editorTradingInfo.value.tradingUpdateUserId,
          tradingUpdateDate: editorTradingInfo.value.tradingUpdateDate,
          tradingTrx: editorTradingInfo.value.tradingTrx,
          deleteTradingFlowIds: props.deleteTradingFlowIds,
          tradingName: editorTradingInfo.value.tradingName,
          tradingPatternInfo: editorTradingInfo.value.tradingPatternInfo,
          tradingFlowList: tradingFlowList,
          selectTradingFlowIds: [tradingFlowId]
        },
      };

      const params = {
        // bff_td_10 取引管理新規登録BFF
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'post_/v1/tradings/{companyId}/manages',
          path: {
            companyId: companyId.value,
          },
        },
        data: data,
      };

      $api
        .request(params)
        .then(res => {
          root.$store.commit('END_PROCESS');
          root.$store.dispatch('SHOW_COMPLETED');
          refresh();
          editMode.value = isForcedCloseUpdateAction.value ? false : !editMode.value;
        })
        .catch(err => {
          root.$store.commit('END_PROCESS');
          if (err.response?.errors?.[0]?.code === 'ETNC0214') {
            root.$store.dispatch('SHOW_ALERT', root.$t('Message.ERROR__DATA_CONFLICT'));
          } else {
            root.$store.dispatch('SHOW_ALERT', err.message);
          }
        });
    };

    // 分納情報を取引管理編集画面に反映します
    const onPartialRegistered = res => {
      isShowPartial.value = false;
      const path = `/trading/?fid=${tradingId}`;
      root.$router.push(path);
    };

    const onCombineRegistered = res => {
      isShowCombine.value = false;
      const path = `/trading/?fid=${tradingId}`;
      root.$router.push(path);
    };

    const closeCombine = () => {
      root.$store.dispatch('SHOW_CONFIRM', root.$t('Message.CONFIRM__NAVIGATION_WITH_UNSAVED_DATA'))
        .then(() => {
          isShowCombine.value = false;
        })
        .catch(() => {});
    };

    const closePartial = () => {
      root.$store.dispatch('SHOW_CONFIRM', root.$t('Message.CONFIRM__NAVIGATION_WITH_UNSAVED_DATA'))
        .then(() => {
          isShowPartial.value = false;
        })
        .catch(() => {});
    };

    const showFlowDetail = (row) => {
      selectTradingId.value = row.otherTradingId || row.tradingId || tradingId;
      selectFlowId.value = row.tradingFlowId;
      root.$store.commit('SET_DRAWER', true);
    };

    /* ========== Lifecycle ========== */

    onMounted(async () => {
      root.$store.commit('SET_DRAWER', false);
      // const data = await fetchCompanies();
      // const optionItems = data.map(item => ({ label: item.name, value: item.id }));
      // setOptions('from', optionItems);
      // setOptions('to', optionItems);
    });

    return {
      lang,
      pageTitle,
      displayTradingFlowId,
      loading,
      editorLoading,
      menuItems,
      isNew,
      isShipper,
      editMode,
      isForcedCloseUpdateAction,
      forcedClose,
      processVisible,
      formComponent,
      formProcessComponent,
      formFlowName,
      rules,
      canEditFlow,
      forbidden,
      copyable,
      canPartial,
      canCombine,
      isShowPartial,
      isShowCombine,
      tradingFlowId,
      tableData,
      tradingInfo,
      filteredSchema,
      flowInfo,
      processData,
      formData,
      editorFlowInfo,
      tmpFlowInfo,
      processList,
      addProcess,
      updateFlowValue,
      removeProcess,
      assignMe,
      handleClickMenu,
      handleSave,
      handleRegister,
      handleCancel,
      handleEdit,
      historyBack,
      onPartialRegistered,
      onCombineRegistered,
      closePartial,
      closeCombine,
      isFwd,
      drawerShow,
      selectTradingId,
      selectFlowId,
      showFlowDetail,
      editable
    };
  },
});
</script>

<style lang="scss" scoped>
/* ---

 TwHeader

--- */
.container {
  padding: 5px 15px 15px;
}

::v-deep .side_drawer {
  width: auto;
  width: 1076px;
  z-index: 10001;
  > .inner {
    padding: 20px 44px 48px;
  }
}

::v-deep .backdrop {
  z-index: 10000;
}

.processHeader span {
  color: #5e5873;
  font-weight: normal;
}

.process-show-switch-form {
  margin-top: 10px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  position: relative;

  & label {
    position: absolute;
    top: -20px;
    left: 28px;
    display: block;
    text-align: center;
    font-size: 12px;
    margin-bottom: 2px;
  }
  & .process-show-switch {
    &::v-deep .el-switch__label {
      & span {
        white-space: pre-wrap;
      }
      &.el-switch__label--right,
      &.el-switch__label--left {
        position: relative;
        width: 20px;
      }
      & .tw-icon-not-view {
        position: absolute;
        top: 0px;
        width: 20px;
        height: 20px;
        background: url(../../../../assets/images/icon_eye.png) no-repeat 0 0;
        background-size: 20px auto;
        background-position: 0 bottom;
      }
      & .tw-icon-view {
        position: absolute;
        top: 0px;
        width: 20px;
        height: 20px;
        background: url(../../../../assets/images/icon_eye.png) no-repeat 0 0;
        background-size: 20px auto;
      }
    }
  }
}

.buttons {
  display: flex;
  flex-shrink: 0;
  padding-right: 20px;
}
</style>
